import RecentViolations from '../components/RecentViolations'

export default function Violations() {
  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div>
        <h2 className="text-2xl font-bold text-gray-900">All Violations</h2>
        <p className="mt-1 text-sm text-gray-500">
          Complete list of FMS Contract violations across all applications
        </p>
      </div>

      {/* Filters */}
      <div className="bg-white rounded-lg shadow p-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <select className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-dii-primary">
            <option>All Applications</option>
            <option>Intelligence</option>
            <option>Assessment</option>
            <option>Benchmark</option>
            <option>Framework</option>
          </select>

          <select className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-dii-primary">
            <option>All Severities</option>
            <option>Critical</option>
            <option>High</option>
            <option>Medium</option>
            <option>Low</option>
          </select>

          <select className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-dii-primary">
            <option>All Types</option>
            <option>Hardcoded Data</option>
            <option>Wrong Dimension</option>
            <option>Missing Provider</option>
            <option>Type Mismatch</option>
          </select>

          <select className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-dii-primary">
            <option>Last 24 Hours</option>
            <option>Last 7 Days</option>
            <option>Last 30 Days</option>
            <option>All Time</option>
          </select>
        </div>
      </div>

      {/* Violations Table */}
      <RecentViolations />
    </div>
  )
}